(() => {
    document.querySelectorAll('.homepage-interlinking-group__header').forEach(group => {
        const interlinks = group.nextElementSibling as HTMLElement;
        const chevron = group.querySelector('.chevron') as HTMLElement;
        const chevronStyle = window.getComputedStyle(chevron);
        if (chevronStyle.display !== 'none' && chevronStyle.visibility !== 'hidden') {
            group.addEventListener('click', () => {
                if (interlinks && chevron) {
                    if (interlinks.style.display === 'block') {
                        interlinks.style.display = 'none';
                        chevron.style.transform = 'rotate(0deg)';
                    } else {
                        interlinks.style.display = 'block';
                        chevron.style.transform = 'rotate(180deg)';
                    }
                }
            });
        }
    });
})();
